import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router'
import {
  SHOW_GOOGLE_SSO, SHOW_GOOGLE_SSO_APP,
} from 'Config/config'
import Recaptcha from 'Components/Recaptcha'
import GoogleSSO from 'Components/GoogleSSO'
import GoogleSSOApp from 'Components/GoogleSSOApp'
import { MODAL_TYPE } from 'Defaults/modals'
import { PhoneInput, HiddenSubmit, Input, PasswordInput, SquareCheckboxWithLabel } from 'Components/Form'


// import css from './styles.js'
import {
  _Col, _Signup, _LoginSwitch, _SubmitCta, _FirstStep,
  _SecondStep, _PasswordTip, _AlreadyHaveAccount, _IamAgentCol,
  _AgentErrorTitle, _SlidingModalTitle,
} from './styles'
import { _Divider } from '../Login/styles'

class Signup extends Component {
  componentDidUpdate(prevProps) {
    // only open register modal if first step is done on listing card
    if(prevProps.step === 1 && this.props.step === 2 && this.props.listingCard) {
      this.props.googleAnalyticsEvent({
        category: 'register',
        action: ['Complete Step 1', `From ${this.props.modalSource}`],
        label: this.props.modalSource,
      })
      if(this.props.listingCard) {
        this.props.openModal({
          modalType: MODAL_TYPE.REGISTER,
          modalData: {
            emailInputValStep1: prevProps.emailInputValStep1,
            gate: prevProps.gate,
          },
          modalSource: this.props.modalSource,
        })
      }
    }
  }

  componentWillUnmount() {
    if(!this.props.listingCard) {
      this.props.resetSignupProcess()
    }
  }

  onFirstStepLoginSwitch = () => {
    const {
      listingCard, openModal, switchToLogin, emailInputValStep1, gate, googleAnalyticsEvent, modalSource,
    } = this.props
    googleAnalyticsEvent({
      category: 'register',
      action: ['Log in Clicked', `From ${modalSource}`],
      label: this.props.modalSource,
    })
    if(!listingCard) {
      switchToLogin()
    } else {
      openModal({
        modalType: MODAL_TYPE.LOGIN,
        modalData: {
          emailInputValStep1,
          gate,
        },
        modalSource: this.props.modalSource,
      })
    }
  }

  render() {
    const {
      isNewsletterSubscribe, onSignupStep1, onSignupStep2, inputsUpdate,
      checkboxUpdate, errors, userDataIsFetching, emailInputValStep1, step, className,
      formTitle, switchToLogin, firstNameVal, hasDelivraAccount, iAmAgentCheckboxUpdate, iAmAgent,
      lastNameVal, phoneVal, completeAccount, isLoadingRecaptcha, loginPage, isMobileApp,
    } = this.props
    let phoneError
    if(errors && errors.phone) {
      phoneError = errors.phone
    } else if(errors && errors.phone_country_code) {
      phoneError = errors.phone_country_code
    } else {
      phoneError = null
    }

    const buttonText = completeAccount ? 'Complete Account' : 'Create an Account'
    return (
      <_Signup
        className={className}
        isSecondStep={step !== 1}
        data-test-id={step === 1 ? 'signup' : 'signupSecondWrap'}
        loginPage={loginPage}
      >

        <h4>
          {
              step === 1 ?
                loginPage ? 'Create an account to begin your home search' :
                  `Create an account ${!formTitle ? '' : 'to ' + formTitle}` : "You're almost there!"
            }
        </h4>
        {
              loginPage && step === 1 && (
                <_SlidingModalTitle>Buy, sell, rent, and invest with industry-leading agents</_SlidingModalTitle>
              )
            }
        {
          step === 1 ?
            <_FirstStep>
              <form data-test-id="step1SignUpForm" onSubmit={onSignupStep1}>
                <Input
                  id="email"
                  type="email"
                  animatedLabel="Email Address"
                  onChange={inputsUpdate}
                  errorText={errors ? errors.email : null}
                  value={emailInputValStep1}
                />
                <_SubmitCta
                  primary
                  medium
                  onClick={onSignupStep1}
                  disabled={userDataIsFetching}
                  loading={userDataIsFetching || isLoadingRecaptcha}
                >
                  Next
                </_SubmitCta>
                <Recaptcha />
                <_Divider>or</_Divider>
                {!isMobileApp ? (SHOW_GOOGLE_SSO && <GoogleSSO loginPage={loginPage} text={'Sign Up'} />) :
                  (SHOW_GOOGLE_SSO_APP && <GoogleSSOApp loginPage={loginPage} text={'Sign Up'}/>)}
                <h5>
                  Already have an account?&nbsp;
                  <_LoginSwitch data-test-id="switchToLogin" type="button" onClick={this.onFirstStepLoginSwitch} >
                    Log in
                  </_LoginSwitch>
                </h5>

              </form>
            </_FirstStep>
            :
            step === 2 ?
              <_SecondStep data-test-id={'signupSecondStep'}>
                <form data-test-id="step2SignUpForm" onSubmit={onSignupStep2}>
                  <_Col isHalfCol>
                    <Input
                      id="first"
                      type="text"
                      animatedLabel="First Name"
                      value={firstNameVal}
                      onChange={inputsUpdate}
                      errorText={errors ? errors.first_name : null}
                    />
                  </_Col>
                  <_Col isHalfCol>
                    <Input
                      id="last"
                      type="text"
                      animatedLabel="Last Name"
                      value={lastNameVal}
                      onChange={inputsUpdate}
                      errorText={errors ? errors.last_name : null}
                    />
                  </_Col>

                  <_Col>
                    <PhoneInput
                      id="phone"
                      onChange={inputsUpdate}
                      errorText={phoneError}
                      default={phoneVal}
                      required
                    />
                  </_Col>

                  <_Col isPasswordCol>
                    <PasswordInput
                      id="signup_password"
                      onChange={inputsUpdate}
                      // value={''}
                      autocomplete="new-password"
                      errorText={errors ? errors.password : null}
                    />
                    <_PasswordTip>Must be at least 8 characters</_PasswordTip>
                  </_Col>

                  {
                    !hasDelivraAccount &&
                      <_Col isCheckboxCol>
                        <SquareCheckboxWithLabel
                          id="Subscribed"
                          name="Subscribed"
                          label="Get market news, insights & expert advice delivered to your inbox. We won’t spam you!" // eslint-disable-line
                          onChange={checkboxUpdate}
                          checked={isNewsletterSubscribe}
                        />
                      </_Col>
                  }

                  <_IamAgentCol isCheckboxCol iAmAgent={iAmAgent}>
                    <SquareCheckboxWithLabel
                      id="regiestedAgent"
                      name="regiestedAgent"
                      label="I am a registered real estate agent" // eslint-disable-line
                      onChange={iAmAgentCheckboxUpdate}
                      checked={iAmAgent}
                    />
                    {
                      iAmAgent ? (
                        <Fragment>
                          <_AgentErrorTitle>
                            <strong>Account Creation Alert</strong>
                          </_AgentErrorTitle>
                          Thank you for your interest.{' '}
                          Account creation for agents is currently{' '}
                          unavailable due to TRREB’s data sharing restrictions.{' '}
                          If you have any questions, please do not hesitate to{' '}
                          <a
                            target="_black"
                            href="https://hq.property.ca/contact-us/"
                            title="contact us"
                          >
                            contact us
                          </a>.
                        </Fragment>
                      ) : ''
                    }
                  </_IamAgentCol>
                  <_Col>
                    <_SubmitCta
                      primary
                      medium
                      // onClick={onSignupStep2}
                      buttonType="submit"
                      disabled={userDataIsFetching || iAmAgent}
                      loading={userDataIsFetching}
                    >
                      {buttonText}
                    </_SubmitCta>
                  </_Col>

                  <_Col isTermsConditionsCol>
                    By creating an account you acknowledge that you have read and agree to the&nbsp;
                    <Link to="/terms" target="_blank">Terms of Service</Link>
                    &nbsp;&amp;&nbsp;
                    <Link to="/privacy" target="_blank">Privacy Policy</Link>.
                  </_Col>

                </form>

                <_AlreadyHaveAccount>
                  <div>Already have an account?</div>
                  <_LoginSwitch onClick={switchToLogin} >Log in</_LoginSwitch>
                </_AlreadyHaveAccount>
              </_SecondStep>

              : ''
        }

        <HiddenSubmit />
      </_Signup>
    )
  }
}


Signup.propTypes = {
  step: PropTypes.number.isRequired,
  onSignupStep1: PropTypes.func.isRequired,
  onSignupStep2: PropTypes.func.isRequired,
  inputsUpdate: PropTypes.func.isRequired,
  checkboxUpdate: PropTypes.func.isRequired,
  // isAccepted: PropTypes.bool,
  emailInputValStep1: PropTypes.string,
  errors: PropTypes.shape({
    phone: PropTypes.string,
    password: PropTypes.string,
    email: PropTypes.string,
    buy: PropTypes.bool,
    sell: PropTypes.bool,
    rent: PropTypes.bool,
    invest: PropTypes.bool,
    accepted: PropTypes.bool,
    subscribed: PropTypes.bool,
    phone_country_code: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),

  userDataIsFetching: PropTypes.bool,
  listingCard: PropTypes.bool,
  resetSignupProcess: PropTypes.func.isRequired,
  openModal: PropTypes.func,
  className: PropTypes.string,
  formTitle: PropTypes.string,
  switchToLogin: PropTypes.func,
  isNewsletterSubscribe: PropTypes.bool,
  gate: PropTypes.string,
  firstNameVal: PropTypes.string,
  lastNameVal: PropTypes.string,
  phoneVal: PropTypes.shape({
    phone: PropTypes.string,
    phone_country_code: PropTypes.string,
  }),
  hasDelivraAccount: PropTypes.bool,
  iAmAgent: PropTypes.bool,
  iAmAgentCheckboxUpdate: PropTypes.func,
  modalSource: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func.isRequired,
  completeAccount: PropTypes.bool,
  isLoadingRecaptcha: PropTypes.bool,
  loginPage: PropTypes.bool,
  isMobileApp: PropTypes.bool,
}

export default Signup
